import { initLinkedCheckboxes } from './components/gforms-linked-checkboxes.js';

// Parcel scopes this file as a module, so expose what non-bundled scripts (ajax-filter.js) call
Object.assign(window, { initClassTerms, initRetinaCover });

jQuery(function() {
	initDropDownClasses();
	initSlickCarousel();
	initFancybox();
	initMobileNav();
	initRetinaCover();
	initOpenClose();
	initSameHeight();
	initBrowserDetect(false, true);
	initFilter();
	initAccordion();
	initCustomOpenClose();
	initCustomForms();
	initSchoolSearch();
	initClassTerms();
	initLinkedCheckboxes();
});

// initialize custom form elements
function initCustomForms() {
	jcf.setOptions('Select', {
		wrapNative: false,
		wrapNativeOnMobile: false,
	});
	jcf.replaceAll('.filter-section');
}

// custom open-close init
function initCustomOpenClose() {
	jQuery('.custom-open-close').customOpenClose({
		activeClass: 'active',
		holder: '.custom-open-close-wrap',
		opener: '.custom-open-close-opener',
		slider: '.custom-open-close-slide',
		list: '.custom-open-close-list',
		animSpeed: 400,
		btnClose: '.btn-close'
	});
}

// align blocks height
function initSameHeight() {
	jQuery('.same-height-holder').sameHeight({
		elements: '.same-height',
		flexible: true,
		multiLine: true
	});

	jQuery('.same-height-holder-js').sameHeight({
		elements: '.same-height-js',
		flexible: true,
		multiLine: true,
		biggestHeight: true,
	});
}

// open-close init
function initOpenClose() {
	ResponsiveHelper.addRange({
		'..1023': {
			on: function() {
				jQuery('.drop-open-close').openClose({
					activeClass: 'active',
					opener: '.opener',
					slider: '.slide',
					animSpeed: 400,
					hideOnClickOutside: true,
					effect: 'slide'
				});
			},
			off: function() {
				jQuery('.drop-open-close').openClose('destroy');
			}
		}
	});
}
function initAccordion() {
	jQuery( ".accordion" ).accordion({
		collapsible: true,
		header:  ".accordion-head",
		heightStyle: "content",
		active: false
	});
}

// slick init
function initSlickCarousel() {
	var win = jQuery(window);
	jQuery('.intro-block-slider').each(function() {
		var holder = jQuery(this);
		var holderClasses = holder.attr('class');
		var holderHtml = holder.html();
		var mode = null;
	});

	jQuery('.intro-block-slider').slick({
		slidesToScroll: 1,
		rows: 0,
		arrows: false,
		dots: true
	});
}

// lightbox init
function initFancybox() {
	jQuery('a.lightbox, [data-fancybox]').fancybox({
		parentEl: 'body',
		margin: [50, 0]
	});
}

// mobile menu init
function initMobileNav() {
	jQuery('body').mobileNav({
		menuActiveClass: 'nav-active',
		menuOpener: '.nav-opener'
	});
}

function initRetinaCover() {
	jQuery('.bg-stretch').retinaCover();
}

var dropDown = false;
// popups init
function initPopups() {
	dropDown = jQuery('.navigation > .has-drop-down').contentPopup({
		mode: 'click',
		popup: '.drop-down',
		btnOpen: '.has-drop-down-a',
		openClass: 'drop-active',
		hideOnClickOutside: 'drop-active'
	});
}

// add classes if item has dropdown
function initDropDownClasses() {
	var win = jQuery(window);

	var applyClasses = function(){
		jQuery('.has-drop-down-a').off();
		jQuery('.has-drop-down-a').removeClass('has-drop-down-a');
		jQuery('.navigation > li').each(function() {
			var item = jQuery(this);
			var drop = item.find('.drop-down');
			if (window.innerWidth > 1024) {
				var link = item.find('a').eq(0);
			} else {
				var link = item.find('a.opener').addClass('has-drop-down-a');
			}

			if (drop.length) {
				item.addClass('has-drop-down');
				if (link.length){
					link.addClass('has-drop-down-a');
				}
			}

		});
		initPopups();
	}
	win.on('resize orientationchange', applyClasses);
	applyClasses();
}

function initSchoolSearch(){
	jQuery(document).on('select2:open', () => {
		document.querySelector('.select2-search__field').focus();
	});

	var selectElement = jQuery( '.select2 select');
	var hiddenElement = selectElement.parents('.gfield').next('.gfield.gform_hidden').find('input[type=hidden]');
	var schoolDisplay = jQuery('.school-display');

	selectElement.select2({
		width: '100%',
			placeholder: 'Click to start typing',
		ajax: {
			url: oh_forms.ajax_url + 'school/load/',
			dataType: 'json',
			delay:	500,
			data: function(params){
				var query = {
					postcode: params.term
				}
				return query;
			}
		}
	}).on('select2:select', function (e) {
		schoolDisplay.html('Checking school is not already subscribed').addClass('active');
		jQuery.ajax({
			url: oh_forms.ajax_url + 'school/check_registered/',
			data: {
				school_id : e.params.data.id,
			},
			success: function(result){
				if(result.results.already_member == 'true'){
					schoolDisplay.html('<strong>This school already has an account registered with us. All school accounts are managed by a lead teacher - please <a href="/contact-us/">contact us</a> if you need help getting in touch with the lead teacher on your account.</strong>').addClass('active');
					selectElement.val(null).trigger('change');
					jQuery(e.currentTarget).parents('.gfield').next('.gfield.gform_hidden').find('input[type=hidden]').val( null );
				}else{
					schoolDisplay.html('<strong>You have selected</strong>: ' + e.params.data.text).addClass('active');
					jQuery(e.currentTarget).parents('.gfield').next('.gfield.gform_hidden').find('input[type=hidden]').val( e.params.data.name );
				}
			}
		});
	});

	if(selectElement.val() !== '' && hiddenElement.val() !==  ''){
		schoolDisplay.html('<strong>You have selected</strong>: ' + hiddenElement.val() ).addClass('active');
	}
}

function initClassTerms(){
	jQuery('.open-term-popup').click(function(){
		jQuery(this).siblings('.term-popup').slideDown();
		return false;
	});
	jQuery('.close-term-popup').click(function(){
		jQuery(this).parents('.term-popup').slideUp();
		return false;
	});
}